export default "/images/9c280c9c0595b26aff7b54eee016ab79.avif";